import { DefaultService } from '@/services/DefaultService';

export default class FaseFenologicaService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    updateSituacao(fasefenologica, contexto = 'agro') {
        return this._http
            .post(
                `${this._env}/${contexto}/cultura/fasefenologica/updatesituacao`,
                fasefenologica,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw err;
                }
            );
    }

    findAll(column, order, page, limit, situacao, idtipocultura, contexto = 'agro', ...params) {
        return this._http
            .get(
                encodeURI(
                    `${this._env}/${contexto}/cultura/fasefenologica.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idtipocultura=${idtipocultura}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error('Problems while jobs are loading');
                }
            );
    }

    findNaoAssociados(column, order, page, limit, idtipocultura, contexto = 'agro', ...params) {
        return this._http
            .get(
                encodeURI(
                    `${this._env}/${contexto}/cultura/fasefenologica/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idtipocultura=${idtipocultura}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw err;
                }
            );
    }

    findAllCombo(params) {
        return this.findAllComboSituacao(1, params);
    }
    findAllComboSituacao(situacao = 1, ...params) {
        return this._http
            .get(
                encodeURI(
                    `${this._env}/agro/cultura/fasefenologica/getcombo.json?situacao=${situacao}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error('Problems while jobs are loading');
                }
            );
    }

    findAllComboByIdCultura(idcultura, ...params) {
        return this._http
            .get(
                encodeURI(
                    `${this._env}/agro/cultura/fasefenologica/getcombo/${idcultura}.json?param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error('Problems while jobs are loading');
                }
            );
    }

    find(id) {
        return this._http
            .get(`${this._env}/agro/cultura/fasefenologica/${id}.json`, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error('Problems while jobs are loading');
                }
            );
    }

    save(form, contexto = 'agro') {
        return this._http
            .post(`${this._env}/${contexto}/cultura/fasefenologica`, form, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw err;
                }
            );
    }
}
